<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    modal-append-to-body
    append-to-body
    destroy-on-close
    width="1100px"
    :close-on-click-modal="false"
    @closed="handelClosed"
  >
    <div class="dialog-content" v-loading="getLoading">
      <couponsTemplate ref="couponsTemplateRef" :form="templateFrom" :disabled="disabled" :couponPlatformType="couponPlatformType"></couponsTemplate>
      <div style="width: 700px;display: flex;flex-direction: row-reverse;">
        <el-button v-if="!disabled" type="primary" @click="submitForm" :loading="loading">提交</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import couponsTemplate from '@/components/couponsTemplate.vue'
import {useCouponsTemplate,useSetTemplateFrom} from '@/components/useCouponsTemplate.js'
import mini from "@/api/mini";
const MiniModel = new mini();

export default {
  name: "couponsTemplateCreat",
  components: {
    couponsTemplate
  },
  props:{
    couponPlatformType:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      getLoading: false,
      loading: false,
      dialogVisible: false,
      title: '优惠券模板创建',
      templateFrom:useCouponsTemplate(),
      type:'',
      disabled: false, // 是否禁用
    }
  },
  methods: {
    async getDetail(row) {
      const res = await MiniModel.couTemplateDetail({
        appKey: localStorage.getItem("appKeyMini"),
        id:row.id
      })
      console.log(res, 'res==couTemplateDetail',res.data.code)
      if(res.data.code !== 200) {
        this.$message.error(res.data.message || '获取详情失败')
        return
      }
      // let templateFromData = useCouponsTemplate()
      // let data = res.data.data
      // templateFromData.type = data.type
      // templateFromData.floorAmount = data.floorAmountBd || ''
      // templateFromData.couponPrice = data.couponPriceBd || ''
      // templateFromData.hallType = data.movieTemplateLimitJson.hallType
      // templateFromData.useType = data.useType
      // templateFromData.cinemaStandardStr = data.movieTemplateLimitJson.cinemaFilterType === 0 ? '全部影院' : data.movieTemplateLimitJson.cinemaClassifyName
      // templateFromData.cinemaClassifyId = data.movieTemplateLimitJson.cinemaClassifyId.split(',') || []
      // templateFromData.cinemaFilterType = data.movieTemplateLimitJson.cinemaFilterType
      // templateFromData.movieIdType = data.movieTemplateLimitJson.movieIdStr ? 1 : 0
      // templateFromData.movieIdSelectList = data.movieTemplateLimitJson.movieIdStr ? data.movieTemplateLimitJson.movieIdStr.split(',') : []
      // templateFromData.name = data.name
      // this.templateFrom = templateFromData
      this.templateFrom = useSetTemplateFrom(res.data.data)
    },
    async submitForm() {
      try{
        this.loading = true
        let data = await this.$refs.couponsTemplateRef.calibration()
        console.log(data,'data==couponsTemplateRef')
        console.log('sdsdsd==1',data)

        let params = {
          ...data.templateData,
          appKey: localStorage.getItem("appKeyMini"),
          couponPlatformType: this.couponPlatformType,
        }
        console.log(this.couponPlatformType,'sdsdsd==2',params)
        // return
        const res = await MiniModel.couTemplateSave(params)
        this.loading = false
        if(res.data.code !== 200) {
          this.$message.error(res.data.message)
          return
        }
        this.$message.success(res.data.message)
        this.$emit('refresh')
        this.handelClosed()
      }catch (err){
        this.loading = false
        console.log('校验失败111', err)
      }
    },
    reset() {
      this.type = ''
      this.disabled = false
      this.loading = false
      this.templateFrom = useCouponsTemplate()
    },
    async handelOpen(type,row) {
      console.log('创建模板2', type, row)
      this.reset()
      this.dialogVisible = true
      this.getLoading = true
      this.$nextTick(() => {
        this.$refs.couponsTemplateRef.open()
      })
      if(type === 1) {
        this.title = '优惠券模板创建'
        this.getLoading = false
        console.log(this.templateFrom,'this.templateFrom222',useCouponsTemplate())
        this.$nextTick(() => {
          this.$refs.couponsTemplateRef.resetForm()
        })
      } else if(type === 2) {
        this.disabled = true
        this.title = '优惠券模板查看'
        await this.getDetail(row)
        this.getLoading = false
      }
    },
    handelClosed() {
      this.dialogVisible = false
    }
  },
}
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/components/couponsTemplateCreat.vue